import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import {
  Button,
  Divider,
  Grid,
  Header,
  Icon,
  Label,
  Popup,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import config from '../../../config';
import { flashErrorMessage, flashSuccessMessage } from '../../actions/flash';
import { serverRequestPost } from '../../actions/fetchM';

import UploadAttachmentForm from '../BookingPaymentPictures/Form';

import LoanAmount from '../../components/LoanAmount';
import CurrencySymbol from '../../components/CurrencySymbol';
import UploadModal from '../../components/UploadModal';
import Timestamp from '../../components/Timestamp';
import { StateAuth } from '../../types';

import PAYMENT_TYPES from '../../constants/paymentTypes';
import BOOKING_FEE_PAYMENT_STATUSES from '../../constants/bookingFeePaymentStatuses';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';
import { hasAnyRequiredRoleIDs, matchGroupIDToSrRoleID } from '../../constants/srRoleAccess';

import { centsToFloat } from '../../utils/numbers/centsFloat';
import { getConstantsLabel } from '../../utils/translation';
import { depositLabel, isVietnamCompany, vnDepositStatusLabel } from '../../utils/vietnam';

class Item extends Component {
  static propTypes = {
    auth: StateAuth,
    backgroundColor: PropTypes.string,
    data: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    bookingData: PropTypes.oneOfType([
      PropTypes.object,
    ]),
    defaultObj: PropTypes.shape({}),
    footer: PropTypes.node,
    hideCancel: PropTypes.bool,
    onCancelTransaction: PropTypes.func,
    onUpdated: PropTypes.func,
    openAttachment: PropTypes.func,
    projectBankAccount: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    projectCurrencies: PropTypes.oneOfType([
      PropTypes.array,
    ]),
    hideHeader: PropTypes.bool,
    token: PropTypes.string,
    t: PropTypes.func,
  }
  static contextTypes = {
    router: PropTypes.object,
    store: PropTypes.object,
  }
  static getPropsToState = (props) => {
    const defaultObj = props.defaultObj;
    const data = Object.assign({}, defaultObj, props.data);
    const projectCurrencies = props.projectCurrencies;
    return {
      data,
      defaultObj,
      popUpState: false,
      projectCurrencies,
      uploadModalState: false,
    };
  }
  constructor(props) {
    super(props);
    const state = Item.getPropsToState(props);

    this.state = {
      genericErrMsg: props.t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }),
      loading: false,
      ...state,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = Item.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  setLoading(loading = false) {
    return new Promise((res) => {
      this.setState({ loading }, () => {
        res(loading);
      });
    });
  }
  getPaymentStatus = (data) => {
    if (data) {
      if (data.onlinePayment && data.onlinePayment.requestStatus !== '') {
        switch (data.onlinePayment.requestStatus) {
          case 'payment_failed':
            return 'online-failed';
          case 'payment_expired':
          case 'rejected':
            return 'online-expired-rejected';
          default:
            return '';
        }
      }
      return data.status;
    }
    return '';
  }
  getPicturesLength = (data) => {
    if (data && data.paymentPictures && data.paymentPictures.length > 0) {
      return data.paymentPictures.length;
    }
    return 0;
  }
  getStatusBasedOnPaymentMethod = payment => (
    payment.paymentMethodTypeID === 'online_payment' &&
    payment.onlinePayment &&
    payment.onlinePayment.requestStatus
      ? payment.onlinePayment.requestStatus
      : payment.status
  )
  setPaymentStatusColor = (paymentStatus) => {
    switch (paymentStatus) {
      case 'paid':
      case 'payment_completed':
        return 'green';
      case 'payment_expired':
      case 'rejected':
        return 'grey';
      default:
        return 'blue';
    }
  }
  // CPI-974 (D): Vietnam is approval-only, so the receipt exists once the payment is 'paid'.
  hasReceiptForStatus = (status) => {
    if (isVietnamCompany(this.props.auth)) return status === 'paid';
    return status === 'paid' || status === 'pending_verification';
  }
  canShowReceiptLink = status => this.hasPaymentReceiptAccess() && this.hasReceiptForStatus(status)
  hasPaymentReceiptAccess = () => {
    const { auth, bookingData } = this.props;
    if (auth.isAdminBasic || auth.isAdmin) return true;
    if (bookingData && bookingData.project && bookingData.project.paymentReceiptAccessGroupIDs) {
      const uGroupIDs = [...auth.groups.map(obj => obj.id)];
      const uSrRoleIDs = matchGroupIDToSrRoleID(uGroupIDs, auth.companyBranch.isExternal);
      return hasAnyRequiredRoleIDs(bookingData.project.paymentReceiptAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  }
  handleUploadModalClose = () => {
    this.setState({ uploadModalState: false });
  }
  handleViewPictures = (e, payment) => {
    e.preventDefault();
    if (this.props.openAttachment) this.props.openAttachment(payment);
  }
  togglePopupState = () => {
    const { popUpState } = this.state;
    this.setState({ popUpState: !popUpState });
  }
  transformProjectBankAccountData = (projectBankAccountID) => {
    let bankText = '';
    const { projectBankAccount } = this.props;
    if (!projectBankAccount) return bankText;
    const activeBankAccount = projectBankAccount.filter(e => e.id === projectBankAccountID);
    if (activeBankAccount.length > 0) bankText = `${activeBankAccount[0].bank} (${activeBankAccount[0].accountNumber})`;
    return bankText;
  }
  triggerAddAttachment = () => {
    this.setState({ popUpState: false, uploadModalState: true });
  }
  triggerCancelTransaction = () => {
    const { data } = this.state;
    this.setState({ popUpState: false });
    if (this.props.onCancelTransaction) this.props.onCancelTransaction(data.id);
  }
  async handleError(store, msg, errorObj, isBugsnag = false) {
    await this.setLoading(false);
    await store.dispatch(flashErrorMessage({ message: msg }));
    if (isBugsnag) Bugsnag.notifyException(errorObj);
  }
  isHideHeader() {
    const { data } = this.state;
    return this.props.hideHeader || data.status === 'cancelled';
  }
  async uploadPictures(e, body) {
    const { t } = this.props;
    e.preventDefault();
    const { data, genericErrMsg } = this.state;
    const { store, router } = this.context;
    try {
      await this.setLoading(true);

      const picResponse = await serverRequestPost(
        `/bookings/${router.params.id}/pictures/?FPID=${data.id}`,
        store,
        this.props.token,
        body,
        {
          credentials: 'include',
          method: 'POST',
          headers: {
            'X-Csrf-Token': this.props.token,
          },
          body,
        },
      );
      await this.setLoading(false);
      if (picResponse.error) {
        this.handleError(store, picResponse.message);
        return;
      }
      this.setState({ uploadModalState: false });
      this.uploadModal.close();
      if (this.props.onUpdated) this.props.onUpdated();
      store.dispatch(flashSuccessMessage({
        header: t('Upload Success', { ns: TRANSLATION_FILES.translation }),
        message: t('Picture(s) successfully uploaded', { ns: TRANSLATION_FILES.translation }),
      }));
    } catch (error) {
      this.handleError(store, genericErrMsg, error, true);
    }
  }
  render() {
    const {
      data,
      projectCurrencies,
      popUpState,
      uploadModalState,
    } = this.state;
    const { auth, t } = this.props;
    const rejectedOnlinePayment = data && data.onlinePayment && data.onlinePayment.requestStatus === 'payment_failed';
    return (
      <Grid.Row>
        <Grid.Column
          mobile={15} tablet={15} computer={15}
          className={`payment-card payment-card-${this.getPaymentStatus(data)}`}
          style={{ backgroundColor: this.props.backgroundColor }}
        >
          {
          this.isHideHeader() ? null : (
            <Grid verticalAlign="middle">
              <Grid.Column textAlign="left" width={data && data.paymentMethodTypeID && data.paymentMethodTypeID !== 'online_payment' ? 8 : 16}>
                <Label
                  className={rejectedOnlinePayment ? 'online-rejected-label' : ''}
                  style={{ textTransform: 'capitalize' }}
                  circular
                  color={!rejectedOnlinePayment ? this.setPaymentStatusColor(this.getStatusBasedOnPaymentMethod(data)) : ''}
                  horizontal
                >
                  {vnDepositStatusLabel(auth, t, this.getStatusBasedOnPaymentMethod(data)) ||
                    getConstantsLabel(
                      t,
                      BOOKING_FEE_PAYMENT_STATUSES,
                      this.getStatusBasedOnPaymentMethod(data),
                    )}
                </Label>
              </Grid.Column>
              {
                data && data.paymentMethodTypeID && data.paymentMethodTypeID !== 'online_payment' ? (
                  <Grid.Column textAlign="right" width={8}>
                    <UploadModal
                      modalState={uploadModalState}
                      trigger={(<span />)}
                      ref={(ref) => { this.uploadModal = ref; }}
                      header="pictures"
                      loading={this.state.loading}
                      onConfirm={(e, file) => {
                        this.uploadPictures(e, file);
                      }}
                      onClose={this.handleUploadModalClose}
                      primary={false}
                      content={opt => (
                        <UploadAttachmentForm
                          ref={(ref) => { this.form = ref; }}
                          fileType="attachment"
                          loading={this.state.loading}
                          onSubmit={opt.onConfirm}
                        />
                      )}
                    />
                    <Popup
                      on="click"
                      open={popUpState}
                      onOpen={this.togglePopupState}
                      onClose={this.togglePopupState}
                      trigger={<Icon
                        color="blue"
                        link
                        name="ellipsis vertical"
                        size="large"
                      />}
                    >
                      <Grid centered celled="internally" className="payment-card-options">
                        {
                          this.canShowReceiptLink(data.status) ? (
                            <Link
                              as="a"
                              className="row"
                              to={`${config.get('bookApiURL')}/bookings/${this.props.data.bookingID}/booking_fee_payments/${this.props.data.id}/receipt/`}
                              target="_blank"
                            >
                              <Grid.Column style={{ marginTop: '0', marginBottom: '0' }}>
                                <Header color="blue" as="h4">{depositLabel(auth, t, 'Payment Receipt')}</Header>
                              </Grid.Column>
                            </Link>
                          ) : null
                        }
                        <a className="row">
                          <Grid.Column
                            style={{ marginTop: '0', marginBottom: '0' }}
                            onClick={this.triggerAddAttachment}
                          >
                            <Header color="blue" as="h4">{t('Add Attachment')}</Header>
                          </Grid.Column>
                        </a>
                        {
                          this.props.hideCancel ? '' : (
                            <a className="row">
                              <Grid.Column
                                style={{ marginTop: '0', marginBottom: '0' }}
                                onClick={this.triggerCancelTransaction}
                              >
                                <Header color="red" as="h4">{t('Cancel Transaction')}</Header>
                              </Grid.Column>
                            </a>
                          )
                        }
                      </Grid>
                    </Popup>
                  </Grid.Column>
                ) : null
              }
            </Grid>
          )
        }
          <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
            <Grid.Column textAlign="left" width={8}>
              {t('Amount')}:
            </Grid.Column>
            <Grid.Column textAlign="right" width={8}>
              <b>
                <LoanAmount
                  projectCurrencies={projectCurrencies}
                  format="0,000,000.00"
                  amount={centsToFloat(data.amountCents)}
                  prefix={<CurrencySymbol />}
                />
              </b>
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
            <Grid.Column textAlign="left" width={8}>
              {t('Method')}:
            </Grid.Column>
            <Grid.Column textAlign="right" width={8}>
              <b>{data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? getConstantsLabel(t, PAYMENT_TYPES, data.paymentMethodTypeID).toUpperCase() : getConstantsLabel(t, PAYMENT_TYPES, data.paymentMethodTypeID)}</b>
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
            <Grid.Column textAlign="left" width={8}>
              {t(data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? 'Request Time' : 'Time')}:
            </Grid.Column>
            <Grid.Column textAlign="right" width={8}>
              {
                data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' && data.onlinePayment && data.onlinePayment.requestedAt ? (
                  <b><Timestamp format="DD/MM/YY hh:mm a" timestamp={data.onlinePayment.requestedAt} /></b>
                ) : (
                  <b><Timestamp format="DD/MM/YY hh:mm a" timestamp={data.createdAt} /></b>
                )
              }
            </Grid.Column>
          </Grid>
          <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
            <Grid.Column textAlign="left" width={8}>
              {t(data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? 'Reference No.' : 'Reference')}:
            </Grid.Column>
            <Grid.Column textAlign="right" width={8}>
              <b>{data.reference}</b>
            </Grid.Column>
          </Grid>
          {
            data.paymentMethodTypeID === 'bank_transfer' || data.paymentMethodTypeID === 'cheque' ? (
              <span>
                {
                  data.transferredToBankID ? (
                    <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                      <Grid.Column textAlign="left" width={8}>
                        {t('Transferred to')}:
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <b>{this.transformProjectBankAccountData(data.transferredToBankID)}</b>
                      </Grid.Column>
                    </Grid>
                  ) : null
                }
              </span>
            ) : null
          }
          {
            data.paymentMethodTypeID === 'virtual_account' ? (
              <span>
                {
                  data.transferredToVABank && data.transferredToVAAccountNumber ? (
                    <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                      <Grid.Column textAlign="left" width={8}>
                        {t('Transferred to')}:
                      </Grid.Column>
                      <Grid.Column textAlign="right" width={8}>
                        <b>{`${data.transferredToVABank} (${data.transferredToVAAccountNumber})`}</b>
                      </Grid.Column>
                    </Grid>
                  ) : null
                }
              </span>
            ) : null
          }
          {
            data.paymentMethodTypeID === 'bank_transfer' || data.paymentMethodTypeID === 'virtual_account' ? (
              <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                <Grid.Column textAlign="left" width={8}>
                  {t('Transferred from')}:
                </Grid.Column>
                <Grid.Column textAlign="right" width={8}>
                  <b>{`${data.transferredFromBank} (${data.transferredFromAccountNumber})`}</b>
                </Grid.Column>
              </Grid>
            ) : null
          }
          {
            data.paymentMethodTypeID === 'credit_card' ? (
              <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                <Grid.Column textAlign="left" width={8}>
                  {t('Card Number')}:
              </Grid.Column>
                <Grid.Column textAlign="right" width={8}>
                  <Header as="h5">XXXX XXXX XXXX {data.creditCardLastFourDigits}</Header>
                </Grid.Column>
              </Grid>
            ) : null
          }
          {
            data && data.paymentMethodTypeID && data.paymentMethodTypeID !== 'online_payment' ? (
              <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                <Grid.Column textAlign="left" width={8}>
                  {t('Attachment')}:
                </Grid.Column>
                <Grid.Column textAlign="right" width={8}>
                  <span>
                    {
                      this.getPicturesLength(data) > 0 ? (
                        <button
                          className="a-button-blue"
                          onClick={e => this.handleViewPictures(e, data)}
                          title={t('View', { ns: TRANSLATION_FILES.translation })}
                        >
                          {`${this.getPicturesLength(data)} ${t('Attachment').toLowerCase()}`}
                        </button>
                      )
                      : <span className="color-gray">{t('No Attachment')}</span>
                    }
                  </span>
                </Grid.Column>
              </Grid>
            ) : (
              <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                <Grid.Column textAlign="left" width={8}>
                  {t('Transaction Time')}:
                </Grid.Column>
                <Grid.Column textAlign="right" width={8}>
                  <span>
                    {
                      data.onlinePayment && data.onlinePayment.payMSPayment && data.onlinePayment.payMSPayment.updated_at && data.onlinePayment.requestStatus && (data.onlinePayment.requestStatus === 'payment_completed' || data.onlinePayment.requestStatus === 'payment_failed') ? (
                        <b><Timestamp format="DD/MM/YY hh:mm a" timestamp={data.onlinePayment.payMSPayment.updated_at} /></b>
                      ) : ''
                    }
                  </span>
                </Grid.Column>
              </Grid>
            )
          }
          {
            data && data.paymentMethodTypeID && data.paymentMethodTypeID === 'online_payment' ? (
              <Grid>
                <Grid.Column only="tablet computer" tablet={5} computer={9} />
                <Grid.Column textAlign="right" mobile={16} tablet={11} computer={7}>
                  <Button
                    fluid
                    color="grey"
                    disabled
                    content={t('Send Request Payment')}
                  />
                </Grid.Column>
              </Grid>
            ) : null
          }
          {
            data.status === 'cancelled' ? (
              <span>
                <Divider />
                <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                  <Grid.Column textAlign="left" width={8}>
                    {t('Status')}:
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={8}>
                    {t('Cancellation')}
                  </Grid.Column>
                </Grid>
                <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                  <Grid.Column textAlign="left" width={8}>
                    {t('Reason')}:
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={8}>
                    {data.cancelledReason}
                  </Grid.Column>
                </Grid>
                <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                  <Grid.Column textAlign="left" width={8}>
                    {t('Deduction')}:
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={8}>
                  - <LoanAmount
                    projectCurrencies={projectCurrencies}
                    format="0,000,000.00"
                    amount={centsToFloat(data.amountCents)}
                    prefix={<CurrencySymbol />}
                  />
                  </Grid.Column>
                </Grid>
                <Grid verticalAlign="middle" style={{ marginTop: '-1rem' }}>
                  <Grid.Column textAlign="left" width={8}>
                    {t('Time')}:
                  </Grid.Column>
                  <Grid.Column textAlign="right" width={8}>
                    <Timestamp format="DD/MM/YY hh:mm a" timestamp={data.updatedAt} />
                  </Grid.Column>
                </Grid>
              </span>

            ) : null
          }
          {
            this.props.footer
          }
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default withTranslation(namespaces)(Item);



// WEBPACK FOOTER //
// ./src/containers/BookingPayment/Item.jsx